export default (state = [], action) => {
  switch (action.type){

    case 'ADD_PROCESSING':
//		console.log('ADD_PROCESSING reducer: '+JSON.stringify(state));
		return true;
		
   case 'REMOVE_PROCESSING':
//		console.log('REMOVE_PROCESSING reducer old state: '+JSON.stringify(state));
		return false;
    	//return state.filter(item => item !== action.id);
	
    default:
		return state;
  }
};